import { ReactNode, useEffect } from 'react';
import { Input, Space } from 'antd';
import { useSearchParams } from 'react-router-dom';

type Props = {
  placeholder?: string;
  extra?: ReactNode;
};

export function TableToolbar({ placeholder = 'Search', extra }: Props) {
  const [params, setParams] = useSearchParams();
  const q = params.get('q') ?? '';

  useEffect(() => {
    /* noop — keeps URL state stable across renders */
  }, [q]);

  return (
    <div style={{ display: 'flex', gap: 12, justifyContent: 'space-between', marginBottom: 12 }}>
      <Input.Search
        allowClear
        defaultValue={q}
        placeholder={placeholder}
        onSearch={(value) => {
          const next = new URLSearchParams(params);
          if (value) next.set('q', value);
          else next.delete('q');
          next.delete('page');
          setParams(next, { replace: true });
        }}
      />
      <Space wrap>{extra}</Space>
    </div>
  );
}
